export enum EntityStoreKey {
  featureFlags = 'featureFlags',
}

export type FeatureFlagsMap = Record<FeatureFlag, boolean>;

export enum FeatureFlag {
  BetaTesters = 'beta-testers',
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  SendLater = 'send-later',
  OfferSocialMedia = 'offer_social_media',
  Webhooks = 'webhooks',
  Gdpr = 'gdpr',
  ProfilePrint = 'profile_print',
  NewCareers = 'new_careers',
  MicrosoftEmailVendor = 'microsoft_email_vendor',
  Billing = 'billing',
  ReportExports = 'report-exports',
  EventDebug = 'debug_event_tracking',
  WysiwygNotes = 'wysiwyg_notes',
  TwoFa = 'two_fa',
}
